module.exports = __webpack_public_path__ + "img/logo_word_white.2d13220f.png";